import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("c7wXz"), parcelRequire.load("aw4wZ"), parcelRequire.load("3bSKP"), parcelRequire.load("3btCG"), parcelRequire.load("h3ESC")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("c7wXz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("aw4wZ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3bSKP")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("3btCG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("h3ESC")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
